import(/* webpackMode: "eager" */ "/app/app/cookies/page.tsx");
